var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-3 is-clickable",on:{"click":_vm.arrowAction}},[_c('span',{staticClass:"title is-4"},[_c('wIcon',{staticClass:"arrow",attrs:{"type":"mdi","icon":("arrow-" + _vm.type)}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }